const redirectURL = () => {
  try {
    const protocol = `${window.location.protocol}//`
    const splitUrl = window.location.hostname.split('.')

    splitUrl[0] === 'www' ? splitUrl.splice(0, 2) : splitUrl.splice(0, 1)

    const mainDomain = splitUrl.join('.')

    return `${protocol}${mainDomain}`
  } catch (e) {
    return process.env.VUE_APP_ERROR_REDIRECTION
  }
}

export default redirectURL
